import Label from '$shared/constants/Label';
import { BaseError } from './BaseError';

class MonitorError extends BaseError {
  constructor() {
    super(Label.Monitor);
  }
}

export const monitorError = new MonitorError();
